/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `7` - 7 days
 * * `30` - 30 days
 * * `60` - 60 days
 * * `90` - 90 days
 * * `custom` - Custom
 * * `none` - None
 */
export enum DefaultExpiresAtEnum {
    _7 = '7',
    _30 = '30',
    _60 = '60',
    _90 = '90',
    CUSTOM = 'custom',
    NONE = 'none',
}
